var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anomaly-plot-container"},[_c('div',{ref:this.uuid,staticClass:"anomaly-plot"})])}
var staticRenderFns = []

export { render, staticRenderFns }